module.exports = __webpack_public_path__ + "static/media/samaritans.9d14bc7e.png";